import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { Spin } from "antd";
import PropTypes from "prop-types";
import {
  fetchObtenirMunicipiComarca,
  fetchObtenirObservador,
  fetchLoginAmbToken
} from "../actions/consultesServidor";
import { getUsuari } from "../reducers";
import ErrorBoundaryWrapper from "./commons/ErrorBoundaryWrapper";
import Perfil from "./Perfil";
import {
  setTitolApartat,
  errorConsultaServidor,
  obtenirDadesUsuariPerIdObservador
} from "../actions";
import {
  TITOL_PERFIL,
  MISSATGE_SPIN_PERFIL,
  MISSATGE_SESSIO_CADUCADA
} from "../constantsFormularis";
import { rutaLogin } from "../routes";
import { calFerLogin, senseRols, tokenDecoded } from "../utils/usuariRols";
import { LOCAL_STORAGE_USER } from "../constantsObservacions";
import { eliminarToken } from "../utils/gestioWebToken";

const dadaNoTrobada = "Dada no trobada";

const obtenirDadesPerfil = (usuari, observador, dadesMunicipiComarca) => ({
  nom: observador.nom,
  cognom1: observador.cognom1,
  cognom2: observador.cognom2,
  fotoUrl: observador.fotoURL,
  usuari: usuari.nom ? usuari.nom : dadaNoTrobada,
  telefon: observador.telefon,
  correu: usuari.correu,
  dataAlta: observador.dataAlta,
  adreça: {
    carrer: observador.carrer,
    numero: observador.numero,
    pis: observador.pis,
    porta: observador.porta,
    codiPostal: observador.codiPostal,
    codiINE: observador.codiINE,
    nomMunicipiObservador:
      Array.isArray(dadesMunicipiComarca) &&
        dadesMunicipiComarca[0] &&
        dadesMunicipiComarca[0].municipi
        ? dadesMunicipiComarca[0].municipi
        : "",
    nomComarcaObservador:
      Array.isArray(dadesMunicipiComarca) &&
        dadesMunicipiComarca[0] &&
        dadesMunicipiComarca[0].comarca
        ? dadesMunicipiComarca[0].comarca
        : ""
  }
});

class PerfilContainer extends Component {
  state = {
    dadesPerfil: {}
  };

  componentDidMount() {
    this._isMounted = true;
    this.recuperarUsuari(this.props.usuari);
    this.props.setTitolApartat(TITOL_PERFIL);
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  recuperarUsuari = usuari => {
    if (!calFerLogin(usuari)) {
      this.tokenTrobat(usuari);
    } else {
      //GET USUARI
      this.props.obtenirDadesUsuariPerIdObservador();

      const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER));
      if (token) {
        fetchLoginAmbToken().then(
          token => {
            this.tokenTrobat(token);
          },
          () => {
            eliminarToken();
            return this.props.errorConsultaServidor(
              { status: 401 },
              MISSATGE_SESSIO_CADUCADA
            );
          }
        );
      } else {
        return this.props.errorConsultaServidor(
          { status: 401 },
          MISSATGE_SESSIO_CADUCADA
        );
      }
    }
  };

  tokenTrobat = usuari => {
    fetchObtenirObservador(usuari.idObservador).then(
      observador => {
        fetchObtenirMunicipiComarca(observador.codiINE).then(
          dadesMunicipiComarca => {
            if (!this._isMounted) {
              return;
            }
            this.setState({
              dadesPerfil: obtenirDadesPerfil(
                usuari,
                observador,
                dadesMunicipiComarca
              )
            });
          },
          error => {
            this.props.errorConsultaServidor(
              error,
              error.titol
                ? error.titol
                : "Error Obtenint dades Municipi i comarca."
            );
          }
        );
      },
      error => {
        this.props.errorConsultaServidor(
          error,
          error.titol ? error.titol : "Error Obtenint dades de l'observador."
        );
      }
    );
  };

  recuperarUsuariRender = usuari => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER));
    if (!token) {
      return <Redirect to={rutaLogin} />;
    }
    if (!calFerLogin(usuari)) {
      return this.tokenTrobatRender(usuari);
    } else {
      return this.tokenTrobatRender(tokenDecoded(token.token));
    }
  };

  tokenTrobatRender = usuari => {
    const { dadesPerfil } = this.state;

    if (senseRols(usuari)) {
      return <Redirect to={rutaLogin} />;
    }

    if (Object.keys(dadesPerfil).length === 0) {
      return <Spin spinning={true} tip={MISSATGE_SPIN_PERFIL} />;
    }

    return <Perfil observador={dadesPerfil} dadesUsuari={usuari} />;
  };

  render() {
    return this.recuperarUsuariRender(this.props.usuari);
  }
}

PerfilContainer.propTypes = {
  usuari: PropTypes.object.isRequired,
  setTitolApartat: PropTypes.func.isRequired,
  obtenirDadesUsuariPerIdObservador: PropTypes.func.isRequired,
  errorConsultaServidor: PropTypes.func.isRequired
};

const mapStateToProps = state => {
  return {
    usuari: getUsuari(state)
  };
};

const mapDispatchToProps = {
  setTitolApartat,
  errorConsultaServidor,
  obtenirDadesUsuariPerIdObservador
};

export default ErrorBoundaryWrapper(
  connect(mapStateToProps, mapDispatchToProps)(PerfilContainer)
);
